export default {
  data() {
    return {
      relationships: [
        {
          key: 'My mother',
          value: 'message.relationshipMother'
        },
        {
          key: 'My father',
          value: 'message.relationshipFather'
        },
        {
          key: 'My wife',
          value: 'message.relationshipWife'
        },
        {
          key: 'My husband',
          value: 'message.relationshipHusband'
        },
        {
          key: 'My sister',
          value: 'message.relationshipSister'
        },
        {
          key: 'My brother',
          value: 'message.relationshipBrother'
        },
        {
          key: 'My son',
          value: 'message.relationshipSon'
        },
        {
          key: 'My daughter',
          value: 'message.relationshipDaughter'
        },
        {
          key: 'My patient',
          value: 'message.relationshipPatient'
        }
      ]
    }
  },
  methods: {
    localizeRelationship(key) {
      let self = this;
      let localized = self.relationships.filter(function (item) {
        return item.key === key;
      });
      if (localized.length === 1) {
        return self.$t(localized[0].value);
      }
      else {
        return key;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Relationships/index.js